
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import {dictApi, deptApi, userApi, teacherApi, roleApi} from "@/api/organization";
    import axios from "axios";
    import baseUrl, {imageUrl} from "../../constants";
    const {regionData} =require("@/js/region/region");
    import utils from "@/common/utils";
    import format from "@/common/format";


    @Component({
        name: "personList",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = "";
        type = "";
        listData = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        showForm = false;
        form = {
            name: "",  //姓名
            gender: "",  //性别
            birthday: "",  //出生日期
            education: "",  //学历
            degree: "",  //学位
            politicalStatus: "",  //政治面貌
            workStartTime: "",  //参加工作日期
            engagedStartTime: "",  //计量工作年限
            engagedEndTime: "",  //计量工作年限
            engagedStartTimeNumber: "",  //计量工作年限
            phone: "",  //手机号码
            organizationName: "",  //所在单位

            region: "",  //地区
            deptId: "",
            organizationId: "",
        } as any
        listTotal = 0;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        organizationName = "";

        setDialog = false;
        addform = {
            idCard: "",  //身份证号
            name: "",  //姓名
            formerName: "",    //曾用名
            gender: "",    //性别
            birthday: "",    //出生日期
            ethnicity: "",    //民族
            phone: "",    //手机号码
            nativePlace: "",    //籍贯
            nativePlaceArr: "",    //籍贯
            birthPlace: "",    //出生地
            birthPlaceArr: "",    //出生地
            education: "",    //最高学历
            degree: "",    //最高学位
            politicalStatus: "",    //政治面貌
            admissionTime: "",    //入党（团、派别）日期
            workStartTime: "",    //参加工作日期
            engagedStartTime: "",    //从事计量工作开始日期
            avatar: "",  //头像
        } as any
        addform2 = {
            // organizationName: "",  //单位名称
            category: "",  //人员类别
            enterDate: "",  //进入单位年月
            enterForm: "",  //进入单位形式
            status: "",  //人员身份
            workType: "",  //现在从事工作
            post: "",  //现任行政职务
            postTime: "",  //任现职务日期
            level: "",  //现行政职级
            levelTime: "",  //取得现行政职级日期
            title: "",  //现技术职称资格
            titleTime: "",  //取得现技术职称资格日期
            currentPosition: "",  //现聘职级
            currentPositionTime: "",  //聘现职级日期
        } as any
        addform3 = {
            pwdOriginal: "",  //密码
        } as any
        roleArr = [];  //角色备选列表
        roleIds = [];  //选中的角色
        rules = {
            idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
            name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        }
        allSelected = [];
        formType = 0;
        useUser = false;
        dictTitle = {
            "C031": "ethnicity",  //民族
            "xl": "education",  //学历
            "xw": "degree",  //学位
            "C029": "politicalStatus",  //政治面貌
            "employee_category": "category",  //人员类别
            "jrbdwxs1": "enterForm",  //进入单位形式
            "rysf": "status",  //人员身份
            "xcsgz1": "workType",  //现在从事工作
            "xrzw": "post",  //现任行政职务
            "xrzj": "level",  //现行政职级
            "xrzg": "title",  //现技术职称资格
            "xpgw": "currentPosition",  //现聘职级
        } as any;
        dictList = {
            ethnicity: [],  //民族
            education: [],  //学历
            degree: [],  //学位
            politicalStatus: [],  //政治面貌
            category: [],  //人员类别
            enterForm: [],  //进入单位形式
            status: [],  //人员身份
            workType: [],  //现在从事工作
            post: [],  //现任行政职务
            level: [],  //现行政职级
            title: [],  //现技术职称资格
            currentPosition: [],  //现聘职级
        } as any
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        regionData = regionData

        loading = false;
        showTree = true;
        depart = {
            saving: false,
            departs:[],
            form: {} as any,
            rules: {
                name: [
                    { required: true, message: "请输入部门名称", trigger: "blur" }
                ]
            },
            selected:null,
            editing:false,
        }
        moving = false;
        movingItemArr = [] as any;
        mechanismTypeData = {};
        userData = null as any;
        tableKey = 0;
        fullScreen = false;

        created() {
            const route = this.$route;
            this.changeType();
            this.headers.Authorization = this.$store.state.Authorization;
            const q = JSON.parse(JSON.stringify(route.query));
            if(q.size){
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            this.userData = this.$store.state.AuthedUser;
            axios.all([
                    this.getDict("C031"),
                    this.getDict("xw"),
                    this.getDict("xl"),
                    this.getDict("C029"),
                    this.getDict("employee_category"),
                    this.getDict("jrbdwxs1"),
                    this.getDict("rysf"),
                    this.getDict("xcsgz1"),
                    this.getDict("xrzw"),
                    this.getDict("xrzj"),
                    this.getDict("xrzg"),
                    this.getDict("xpgw"),
                    this.listDept(),
                    this.listRole(),
                ],
            ).then(axios.spread((acct,perms)=>{
                this.getConfig();
                this.listDict();
            }))
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list();
            }
            this.tableClearSelect();
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }


        //获取角色
        listRole(){
            roleApi.list(0,undefined).then((r:any)=>{
                if(r.data.result === 0){
                    this.roleArr = r.data.data;
                }
            })
        }
        reset(){
            for(const f in this.form){
                this.form[f] = "";
            }
            this.refresh();
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }
        //region 部门管理
        listDept(){
            //如果没有单位，无法加载部门
            if(!this.userData.organizationId || this.userData.status == "3") return;
            this.loading = true;
            deptApi.tree(null)
                .then((r:any)=>{
                    if(r.data.result === 0){
                        this.depart.departs = r.data.data;
                    }
                    this.loading = false;
                }).catch(()=>{
                this.loading = false;
            });
        }
        addDepart(parent: any){
            this.depart.editing = true;
            this.$nextTick(()=>{
                let $form = this.$refs['form_depart'] as HTMLFormElement;
                $form.resetFields();
                this.depart.form = {parentId:parent.id};
            });
        }
        updateDepart(depart: any){
            this.depart.editing = true;
            this.$nextTick(()=>{
                let $form = this.$refs['form_depart'] as HTMLFormElement;
                $form.resetFields();
                this.depart.form = Object.assign({}, depart, {children:[]});
            });
        }
        saveDepart(){
            let $form = this.$refs['form_depart'] as HTMLFormElement;
            $form.validate((valid: any) => {
                if (valid) {
                    this.depart.saving = true;
                    let request;
                    if(this.depart.form.id){
                        request = deptApi.updateName(this.depart.form.id, this.depart.form.name)
                    } else {
                        request = deptApi.add({parentId: this.depart.form.parentId, name: this.depart.form.name})
                    }

                    request.then((r:any) => {
                        this.depart.saving = false;
                        if(r.data.result === 0){
                            this.depart.editing = false;
                            this.$message.success("保存成功")
                            this.listDept();
                        }
                    }).catch(()=>{
                        this.depart.saving = false;
                    })
                } else {
                    return false;
                }
            });
        }
        deleteDepart(depart: any){
            this.$confirm("确实要删除部门[" + depart.name + "]吗？","确认操作",{type:"warning"}).then(()=>{
                deptApi.delete(depart.id).then((r:any)=>{
                    if(r.data.result === 0){
                        this.listDept();
                        this.handleClick();
                    }
                })
            })
        }
        selectDept(data: any){
            this.depart.selected = data;
            this.form.deptId = data.id;
            this.handleClick();
        }

        moveTeacher(arr: any){
            this.movingItemArr = arr;
            this.moving = true;
        }
        moveToHere(dept: any){
            this.$confirm("确实要将用户" + this.getNameString(this.movingItemArr,"name") + "移动到部门" + dept.name + "吗？","确认操作",{type:"info"}).then(r=>{
                userApi.moveToDept({
                    ids: this.getNameString(this.movingItemArr,"id"),
                    deptId: dept.id
                }).then((r: any)=>{
                    if(r.data.result === 0){
                        this.movingItemArr = [];
                        this.moving = false;
                        this.$message.success("移动用户成功");
                        this.handleClick();
                    }
                })
            });
        }
        getNameString(dataArr: any, title: string){
            return dataArr.flatMap((e:any)=>e[title]).join(",")
        }
        //endregion

        //上传监控
        handleAvatarSuccess(res: any, file: any) {
            if(res.result === 0){
                const rData = res.data;
                this.addform.avatar = rData;
                this.$message.success("上传头像成功");
            }
        }
        //上传头像监控
        beforeAvatarUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG 或 PNG格式!');
            }
            return (isJPG||isPNG);
        }

        getConfig() {
            userApi.getUserConfig({name: "personPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.handleClick();
                }
            })
        }
        listDict(){
            //单位类别
            dictApi.listDictItem({typeCode : "dwlb"}).then((r) => {
                if(r.data.result === 0){
                    const mechanismTypeData = {} as any;
                    const dataList = r.data.data;
                    dataList.forEach((d: any) => {
                        d.dictValue+="人员";
                        mechanismTypeData[d.dictKey] = d;
                    });
                    mechanismTypeData['5'] = {dictValue: '所在单位人员管理'}
                    this.mechanismTypeData = mechanismTypeData;
                }
            });
        }
        getDict(typeCode: string) {
            return dictApi.listDictItem({
                typeCode: typeCode
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    if(this.dictTitle[typeCode]){
                        const b = this.dictTitle[typeCode] as string;
                        this.dictList[b] = rData;
                        if(rData.length>0){
                            if(this.addform[b] !== undefined){
                                this.addform[b] = rData[0].dictValue
                            }else if(this.addform2[b] !== undefined){
                                this.addform2[b] = rData[0].dictValue
                            }
                        }
                    }
                }
            })
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }
        handleClick() {
            this.tableClearSelect();
            if(this.type == "5"){
                this.showTree = true;
            }else{
                this.showTree = false;
            }
            this.refresh();
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        list() {
            const route = this.$route;
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            // if(JSON.stringify(q) != JSON.stringify(route.query)){
            //     this.$router.replace({name:route.name!,query: q})
            // }

            const depart = this.depart.departs.find((t:any) => t.id === this.form.deptId) as any;
            if (depart && depart.parentId === 0) {
                this.form.deptId = "";
            }
            if(this.form.engagedStartTimeNumber && !isNaN(this.form.engagedStartTimeNumber) && Number(this.form.engagedStartTimeNumber) >= 0){
                const tiem = utils.toYearDate(this.form.engagedStartTimeNumber);
                const tiem2 = utils.toYearDate(Number(this.form.engagedStartTimeNumber)+1);
                this.form.engagedStartTime = format(tiem2, 'YYYY-MM-DD') + " 00:00:00";
                this.form.engagedEndTime = format(tiem, 'YYYY-MM-DD') + " 00:00:00";
            }else{
                this.form.engagedStartTime = "";
                this.form.engagedEndTime = "";
            }

            const userData = this.userData;
            if(this.type == "5"){
                // 所在单位才需要添加功能和单位id
                this.form.organizationId = userData.organizationId;
                this.organizationName = userData.organizationName;
            }else if(this.type == '6'){
              this.form.organizationId = userData.organizationId;
            }else{
                this.form.organizationId = "";
                this.form.deptId = "";
                this.form.region = userData.organizationRegion;
            }

            const params = {
                ...this.listParam,
                organizationType: ['5', '6'].indexOf(this.type) > -1 ?'':this.type,
                ...this.form,
            }
            userApi.list(params).then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.listData = rData.records;
                    this.listTotal = rData.total;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "personPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        resetAddform(){
            for(const l in this.addform){
                this.addform[l] = "";
            }
            for(const l in this.addform2){
                this.addform2[l] = "";
            }
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        showUserData(row: any){
            const firstRouterText = this.$route.path.split("/")[1];
            this.$router.push("/"+firstRouterText+"/userData/2/"+(this.type=='5'?1:0)+"/"+ row.id);
        }
        //0新增  1编辑 2查看  3删除  4移动
        toDetail(type: number){
            this.resetAddform();
            const dataArr = this.allSelected as any;
            let id = 0;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
            }
            if(type == 4){
                //移动
                this.moveTeacher(dataArr)
                return;
            }
            const firstRouterText = this.$route.path.split("/")[1];
            this.$router.push("/"+firstRouterText+"/userData/"+type+"/"+(this.type=='5'?1:0)+'/'+id + "?deptId="+this.form.deptId);
            // if(id != 0){
            //     userApi.loadDetail({id: id}).then(r => {
            //         if (r.data.result === 0) {
            //             const rData = r.data.data as any;
            //             if(rData.userBaseInfo){
            //                 if(rData.userBaseInfo.nativePlace){
            //                     rData.userBaseInfo.nativePlaceArr = rData.userBaseInfo.nativePlace.split(",");
            //                 }
            //                 if(rData.userBaseInfo.birthPlace){
            //                     rData.userBaseInfo.birthPlaceArr = rData.userBaseInfo.birthPlace.split(",");
            //                 }
            //                 this.addform = rData.userBaseInfo;
            //             }
            //             if(rData.userEmployeeInfo){
            //                 this.addform2 = rData.userEmployeeInfo;
            //             }
            //             if(rData.userLoginInfo){
            //                 this.addform3.pwdOriginal = rData.userLoginInfo.pwdOriginal
            //                 this.useUser = true;
            //             }else{
            //                 this.useUser = false;
            //             }
            //             if(rData.roleIds){
            //                 this.roleIds = rData.roleIds;
            //             }else{
            //                 this.roleIds = [];
            //             }
            //         }
            //     })
            // }
            // this.formType = type;
            // this.setDialog = true;
        }
        saveBtn() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    let params = {
                        userBaseInfo: this.addform,
                        userEmployeeInfo: this.addform2
                    } as any
                    if(this.useUser){
                        this.addform3.name = this.addform.idCard;
                        params.userLoginInfo = this.addform3
                    }
                    if(params.userBaseInfo.nativePlaceArr){
                        params.userBaseInfo.nativePlace = params.userBaseInfo.nativePlaceArr.join(",");
                    }
                    if(params.userBaseInfo.birthPlaceArr){
                        params.userBaseInfo.birthPlace = params.userBaseInfo.birthPlaceArr.join(",");
                    }
                    params.userBaseInfo.departmentId = this.form.deptId;
                    params.roleIds = this.roleIds;
                    userApi.addOrUpdateUser(params).then(r => {
                        this.$message.success("保存成功");
                        this.setDialog = false;
                        this.refresh();
                    })
                }
            })
        }
        del(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userApi.delUser({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        changeType(){
            const route = this.$route;
            const type = route.params.type;
            this.type = type;
            if(route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }
            // switch (type) {
            //     case "0":
            //         this.title = "计量器具使用单位人员";
            //         break;
            //     case "1":
            //         this.title = "法定计量技术机构人员";
            //         break;
            //     case "2":
            //         this.title = "其他计量技术机构人员";
            //         break;
            //     case "3":
            //         this.title = "计量行政管理部门人员";
            //         break;
            //     case "4":
            //         this.title = "其他人员信息";
            //         break;
            //     case "5":
            //         this.title = "所在单位人员信息";
            //         break;
            // }
        }

        // @Watch("$route.path")
        // get$routePath() {
        //     this.changeType();
        //     this.handleClick();
        // }

    }
